<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftBase from '../../../../../shifts/components/ShiftBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <ShiftBase />
</template>